import * as createjs from 'createjs-module';

export class CjGraphics extends createjs.Graphics {
  constructor() {
    super();
  }
}